export default __webpack_public_path__ + "static/media/AppStore.83055224.png";